import axios from "axios";
import { AccountType } from "models/account_type";
import { ArquivoUpload } from "models/arquivo_upload";
import { CentroCusto } from "models/centro_custo_type";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { ContasReceber } from "models/contas_receber";
import { ContaFinanceiro } from "models/conta_financeiro";
import { Depto } from "models/depto_type";
import { LancamentoFinanceiro } from "models/lancamento_type";
import { PessoaType } from "models/person_type";
import { UsuarioModel } from "models/user_model";
import moment from "moment";
import { useEffect, useRef, useState } from "react";

const useContasReceber = () => {
  const [list, setAccountTypeList] = useState<ContasReceber[]>([]);
  const [clients, setClients] = useState<PessoaType[]>();
  const [selectedClient, setSelectedClient] = useState<PessoaType>(null);
  const [filiais, setFiliais] = useState<PessoaType[]>();
  const [selectedFilial, setSelectedFilial] = useState<PessoaType>(null);
  const [usuario, setUsuario] = useState<UsuarioModel>();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [error, setError] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [accountSelected, setAccountSelected] = useState<ContasReceber>(null);
  const [categoria, setCategoria] = useState<AccountType[]>([]);
  const [itemList, setItemList] = useState<LancamentoFinanceiro[]>([]);
  const [oldList, setOldList] = useState<LancamentoFinanceiro[]>([]);
  const cancelRef = useRef();

  const [depto, setDepto] = useState<Depto[]>([]);
  const [selectedDepto, setSelectedDepto] = useState<Depto>(null);
  const [centroCusto, setCentroCusto] = useState<CentroCusto[]>([]);
  const [selectedCentroCusto, setSelectedCentroCusto] =
    useState<CentroCusto>(null);
  const [condicaoPagamentos, setCondicaoPagamentos] = useState<
    CondicaoPagamento[]
  >([]);
  const [selectedCondicaoPagamentos, setSelectedCondicaoPagamentos] =
    useState<CondicaoPagamento>(null);

  const [contaFinanceiroLista, setContaFinanceiroLista] = useState<
    ContaFinanceiro[]
  >([]);
  const [selectedConta, setSelectedConta] = useState<ContaFinanceiro>(null);
  const [users, setUsers] = useState<UsuarioModel[]>([]);
  const [selectedUser, setSelectedUser] = useState<UsuarioModel>();

  const add = () => {
    showModal(true);
  };

  const loadData = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/contas-receber/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setAccountTypeList(response.data);
    }
  };

  const loadClient = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/orcamento/clients/" + userData?.idEmpresa
    );
    if (response.data) {
      setClients(response.data);
    }
  };

  const loadFilial = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/orcamento/filial/" + userData?.idEmpresa
    );
    if (response.data) {
      setFiliais(response.data);
    }
  };

  const loadCategoria = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/conta-tipo/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setCategoria(response.data);
    }
  };

  const loadFinanceiro = async (id: string) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/lancamento/contaspagar/" + id
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setItemList(response.data);
      setOldList(response.data)
    }
  };

  const loadDepto = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/departamento/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setDepto(response.data);
    }
  };

  const loadPagamento = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);

    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/condicao-pagamento/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setCondicaoPagamentos(response.data);
    }
  };

  const loadContaFinaceiro = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/conta-financeiro/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setContaFinanceiroLista(response.data);
    }
  };

  const cleanInput = () => {
    setAccountSelected(null);
    setSelectedClient(null);
    setSelectedUser(null);
    setItemList([]);
  };

  const validateField = (condition: any, errorMessage: string) => {
    if (!condition) {
      showError("Erro!", errorMessage);
      return false;
    }
    return true;
  };

  const validate = () => {
    let response = true;

    const total = itemList.reduce((value, acc) => acc.valor + value, 0);
    const validateItem = total < accountSelected.valor;

    response =
      validateField(
        !validateItem,
        "O valor dos lançamentos não pode ser menor do que o valor total"
      ) && response;

    response = validateField(selectedClient, "Selecione o Cliente") && response;
    response =
      validateField(
        selectedFilial && selectedFilial?.id !== "0",
        "Selecione a Filial de Saída"
      ) && response;
    response =
      validateField(accountSelected?.vencimento, "Selecione o Vencimento") &&
      response;
    response =
      validateField(
        accountSelected?.valor && accountSelected.valor >= 0,
        "Preencha Corretamente o valor"
      ) && response;
    response =
      validateField(
        accountSelected?.documento,
        "Preencha Corretamente o Número do Documento"
      ) && response;
    response =
      validateField(
        accountSelected?.emissao,
        "Preencha Corretamente a Data de Emissão"
      ) && response;
    response =
      validateField(
        accountSelected?.observcao,
        "Preencha Corretamente o histórico da conta"
      ) && response;
    response =
      validateField(
        accountSelected?.status && accountSelected?.status !== "0",
        "Preencha Corretamente o Status"
      ) && response;
    response =
      validateField(
        accountSelected?.regime && accountSelected?.regime !== "0",
        "Preencha Corretamente o Regime Contábil"
      ) && response;
    response =
      validateField(
        accountSelected?.tipoLancamentoId &&
          accountSelected?.tipoLancamentoId !== "0",
        "Preencha Corretamente a Conta"
      ) && response;
    response =
      validateField(
        accountSelected?.tipoRecebimento &&
          accountSelected?.tipoRecebimento !== "0",
        "Preencha Corretamente o tipo de recebimento."
      ) && response;

      response =
      validateField(selectedDepto, "Selecione o Departamento") && response;

      response =
      validateField(selectedCentroCusto, "Selecione o Centro de Custo") &&
      response;

      response =
      validateField(
        selectedCondicaoPagamentos,
        "Selecione a Forma de Pagamento"
      ) && response;

      response =
      validateField(
        accountSelected?.origem,
        "Preencha Corretamente o campo Origem"
      ) && response;

      response =
      validateField(
        selectedConta ,
        "Preencha Corretamente a conta para baixa"
      ) && response;
      response =
      validateField(
        selectedUser,
        "Selecione o Responsável"
      ) && response;

    return response;
  };

  const changeClient = (item: string) => {
    const selected = clients?.find((f) => f.id === item);
    if (selected) {
      setSelectedClient(selected);
    }
  };

  const changeFiliais = (item: string) => {
    const selected = filiais?.find((f) => f.id === item);
    if (selected) {
      setSelectedFilial(selected);
    }
  };

  const changeDepto = (item: string) => {
    const selected = depto?.find((f) => f.id === item);
    if (selected) {
      setSelectedDepto(selected);
      setCentroCusto(selected.CentroCusto);
    }
  };

  const changeCentroCusto = (item: string) => {
    const selected = centroCusto?.find((f) => f.id === item);
    if (selected) {
      setSelectedCentroCusto(selected);
    }
  };

  const changeCondicaoPagamento = (item: string) => {
    const selected = condicaoPagamentos?.find((f) => f.id === item);
    if (selected) {
      setSelectedCondicaoPagamentos(selected);
    }
  };

  const changeInput = (value: any, type: string) => {
    switch (type) {
      case "empresaSaiadaId":
        setAccountSelected({ ...accountSelected, empresaSaiadaId: value });
        break;
      case "documento":
        setAccountSelected({ ...accountSelected, documento: value });
        break;
      case "emissao":
        setAccountSelected({ ...accountSelected, emissao: value });
        break;
      case "vencimento":
        setAccountSelected({ ...accountSelected, vencimento: value });
        break;
      case "valor":
        setAccountSelected({ ...accountSelected, valor: value });
        break;
      case "observcao":
        setAccountSelected({ ...accountSelected, observcao: value });
        break;
      case "tipoLancamentoId":
        setAccountSelected({ ...accountSelected, tipoLancamentoId: value });
        break;
      case "status":
        setAccountSelected({ ...accountSelected, status: value });
        break;
      case "regime":
        setAccountSelected({ ...accountSelected, regime: value });
        break;
      case "tipoRecebimento":
        setAccountSelected({ ...accountSelected, tipoRecebimento: value });
        break;
      case "formaRecebimento":
        setAccountSelected({ ...accountSelected, formaRecebimento: value });
        break;
      case "origem":
        setAccountSelected({
          ...accountSelected,
          origem: value,
        });
        break;
    }
  };

  const changeConta = (item: string) => {
    const selected = contaFinanceiroLista?.find((f) => f.id === item);
    if (selected) {
      setSelectedConta(selected);
    }
  };

  const addRegister = async (list: any[]) => {
    const obj = {
      clientId: selectedClient.id,
      data: new Date(),
      dataCriacao: new Date(),
      dataEdicao: new Date(),
      documento: accountSelected.documento,
      emissao: accountSelected.emissao,
      empresaSaiadaId: selectedFilial.id,
      idEmpresa: usuario.idEmpresa,
      formaRecebimento: accountSelected.formaRecebimento,
      tipoLancamentoId: accountSelected.tipoLancamentoId,
      tipoRecebimento: accountSelected.tipoRecebimento,
      observcao: accountSelected.observcao,
      regime: accountSelected.regime,
      status: accountSelected.status,
      valor: accountSelected.valor,
      vencimento: accountSelected.vencimento,
      centroCustoId : selectedCentroCusto.id,
      condicaoPagamentoId: selectedCondicaoPagamentos.id,
      contaFinanceiroId: selectedConta.id,
      origem: accountSelected?.origem,
      usuarioId: selectedUser?.id,
    };

    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/contas-receber/",
      obj
    );
    if (response.data) {
      const item: ContasReceber = response.data;
      if (list.length > 0) {
        const imageList = await uploadPictures(list);
        for (let i = 0; i < imageList.length; i++) {
          const image = imageList[i];
          const arquivo = {
            contasReceberId: item.id,
            arquivoId: image.id,
          };
          await axios.post(
            process.env.REACT_APP_API_URL + "/contas-receber/arquivo/create",
            arquivo
          );
        }
      }
      if (itemList.length > 0) {
        for (let j = 0; j < itemList.length; j++) {
          const element = itemList[j];
          const finan = {
            acrescimo: element.acrescimo,
            competencia: element.competencia,
            data: element.data,
            desconto: element.desconto,
            idEmpresa: element.idEmpresa,
            idPessoa: element.idPessoa,
            texto: `Referente a conta a receber de ${moment(
              element.data
            ).format("DD/MM/yyyy")} com vencimento em ${moment(
              element.vencimento
            ).format("DD/MM/yyyy")}`,
            vencimento: element.vencimento,
            valor: element.valor,
            tipo: element.tipo,
            contaPagarId: item.id,
            tipoRecebimento: element.tipoRecebimento,
            obs: element.obs ?? ""

          };
          await axios.post(process.env.REACT_APP_API_URL + "/lancamento", finan);
        }
      }
      setLoading((prev) => (prev = false));
      cleanInput();
      showModal(false);
    }
  };

  const updateRegister = async (list: any[]) => {
    const obj = {
      id: accountSelected.id,
      clientId: selectedClient.id,
      dataEdicao: new Date(),
      documento: accountSelected.documento,
      emissao: accountSelected.emissao,
      empresaSaiadaId: selectedFilial.id,
      idEmpresa: usuario.idEmpresa,
      formaRecebimento: accountSelected.formaRecebimento,
      tipoLancamentoId: accountSelected.tipoLancamentoId,
      tipoRecebimento: accountSelected.tipoRecebimento,
      observcao: accountSelected.observcao,
      regime: accountSelected.regime,
      status: accountSelected.status,
      valor: accountSelected.valor,
      vencimento: accountSelected.vencimento,
      centroCustoId : selectedCentroCusto.id,
      condicaoPagamentoId: selectedCondicaoPagamentos.id,
      contaFinanceiroId: selectedConta.id,
      origem: accountSelected?.origem,
      usuarioId: selectedUser?.id,
    };

    const response = await axios.patch(
      process.env.REACT_APP_API_URL + "/contas-receber/" + accountSelected.id,
      obj
    );
    if (response.data) {
      const item: ContasReceber = response.data;
      const newlist: any[] = [];
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          const itemValue = list[i];
          const existe = accountSelected?.ContasReceberArquivo.find((ca) =>
            ca?.arquivo?.fileName?.includes(itemValue?.name)
          );
          if (!existe) {
            newlist.push(itemValue);
          }
        }

        if (newlist.length > 0) {
          const imageList = await uploadPictures(newlist);
          for (let i = 0; i < imageList.length; i++) {
            const image = imageList[i];
            const arquivo = {
              contasReceberId: item.id,
              arquivoId: image.id,
            };
            await axios.post(
              process.env.REACT_APP_API_URL + "/contas-receber/arquivo/create",
              arquivo
            );
          }
        }
      }
      if (oldList.length > 0) {
        for (let index = 0; index < oldList.length; index++) {
          const el = oldList[index];
            console.log(el, 'uiaaaa');
            axios.delete(process.env.REACT_APP_API_URL + "/lancamento/" + el.id);

        }
        for (let j = 0; j < itemList.length; j++) {
          const element = itemList[j];
          const finan = {
            acrescimo: element.acrescimo,
            competencia: element.competencia,
            data: element.data,
            desconto: element.desconto,
            idEmpresa: element.idEmpresa,
            idPessoa: element.idPessoa,
            texto: `Referente a conta a receber de ${moment(
              element.data
            ).format("DD/MM/yyyy")} com vencimento em ${moment(
              element.vencimento
            ).format("DD/MM/yyyy")}`,
            vencimento: element.vencimento,
            valor: element.valor,
            tipo: element.tipo,
            contaPagarId: item.id,
            tipoRecebimento: element.tipoRecebimento,
            obs: element.obs ?? ""
          };
          await axios.post(process.env.REACT_APP_API_URL + "/lancamento", finan);
        }
      }
      setLoading((prev) => (prev = false));
      cleanInput();
      showModal(false);
    }
  };

  const save = async (list: any) => {
    if (validate()) {
      setLoading(true);
      if (accountSelected?.id === undefined) {
        await addRegister(list);
      } else {
        await updateRegister(list);
      }
      setLoading(false);
      showModal(false);
      cleanInput();
      await loadData();
    }
  };

  const uploadPictures = async (list: any[]) => {
    let formData = new FormData();
    if (list.length > 0) {
      for (let i = 0; i < list.length; i++) {
        const file = list[i];
        formData.append("arquivos", file);
      }
    }
    const response = await axios.postForm(
      process.env.REACT_APP_API_URL + "/arquivo/multiplo",
      formData
    );
    if (response.data) {
      const newlist: ArquivoUpload[] = response.data;
      return newlist;
    }
  };

  const showModal = (show: boolean) => {
    setShow(show);
    setError(false);
    if (!show) {
      cleanInput();
    }
  };

  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };

  const closeError = () => {
    setError(false);
  };

  const getLink = async (id: string) => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/arquivo/" + id);
    console.log(response, "response.data");
    if (response.data) {
      return response.data;
    }
  };

  const edit = async (item: ContasReceber) => {
    showModal(true);
    setAccountSelected(item);
    changeClient(item?.clientId);
    changeFiliais(item?.empresaSaiadaId);
    changeUser(item?.usuarioId);
    changeDepto(item?.centroCusto?.departamentoId);
    changeCentroCusto(item?.centroCustoId);
    changeConta(item?.contaFinanceiroId);
    changeCondicaoPagamento(item?.condicaoPagamentoId);
    await loadFinanceiro(item.id);
  };

  const showDeleteModal = (item: ContasReceber) => {
    setShowDelete(true);
    setAccountSelected(item);
  };

  const closeDelete = () => {
    setShowDelete(false);
  };

  const deletar = async () => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + "/contas-receber/" + accountSelected?.id
    );
    if (response.data) {
      await loadFinanceiro(accountSelected?.id);

      if (itemList.length > 0) {
        for (let index = 0; index < itemList.length; index++) {
          const el = itemList[index];
          try {
            axios.delete(process.env.REACT_APP_API_URL + "/lancamento/" + el.id);
          } catch (e) {
            console.log(e);
          }
        }
      }
      setLoading((prev) => (prev = false));
      showModal(false);
      setAccountSelected(null);
      setShowDelete(false);
      await loadData();
    }
  };

  const addRowItem = (item: LancamentoFinanceiro) => {
    const itens = [...itemList];
    const existe = itens.find(
      (a) =>
        moment(a.vencimento).format("DD/MM/yyyy") ===
        moment(item.vencimento).format("DD/MM/yyyy")
    );
    console.log(existe, "existe");
    if (existe) {
      showError("Erro!", "Lançamento Já Cadastrado");
    } else {
      itens.push(item);
    }
    setItemList(itens);
  };

  const deleteRow = (item: LancamentoFinanceiro) => {
    const newList = itemList.filter((dt) => dt !== item);
    setItemList(newList);
  };

  const editRow = (item: LancamentoFinanceiro) => {
    const newItems: LancamentoFinanceiro[] = itemList.map((existingItem) => {
      if (
        moment(existingItem.vencimento).format("DD/MM/yyyy") ===
        moment(item.vencimento).format("DD/MM/yyyy")
      ) {
        return item;
      }
      return existingItem;
    });
    setItemList(newItems);
  };

  const changeUser = (item: string) => {
    const selected = users?.find((f) => f.id === item);
    if (selected) {
      setSelectedUser(selected);
    }
  };

  const loadUsers = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/user/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setUsers(response.data);
    }
  };



  const generateParcela = (
    item: string,
    vencimento: Date,
    valor: number,
    fornecedor: string,
    tipoRecebimento: string,
  ) => {
    const newList: LancamentoFinanceiro[] = [];

    const selected = condicaoPagamentos?.find((f) => f.id === item);
    const sFrn = clients.find((a) => a.id === fornecedor);

    if (selected) {
      setSelectedCondicaoPagamentos(selected);
    }
    if (!vencimento) {
      showError("Erro!", "Selecione o dia de vencimento!");
      return;
    }
    if (!tipoRecebimento) {
      showError("Erro!", "Preencha corretamente o campo de tipo de recebimento!");
      return;
    }

    if (!valor) {
      showError("Erro!", "Preencha corretamente o campo valor!");
      return;
    }

    if (!selectedClient) {
      showError("Erro!", "Selecione o cliente!");
      return;
    }
    const valorParcela = valor / selected?.parcelas;
    const diaCorrente = moment();
    const itemDate = moment(vencimento).add({ day: 1 }).format("DD");
    for (let i = 0; i < selected?.parcelas; i++) {
      let dataParcela = moment().set("date", Number(itemDate));
      if (diaCorrente.isAfter(dataParcela)) {
        dataParcela.add({ month: 1 });
      }
      const newDate = dataParcela
        .add({ month: i })
        .format("YYYY-MM-DD")
        .toString();
      const itemData = new Date(newDate);

      const obj: LancamentoFinanceiro = {
        acrescimo: 0,
        competencia: accountSelected?.emissao,
        data: new Date(),
        desconto: 0,
        idEmpresa: usuario?.idEmpresa,
        idPessoa: sFrn?.id,
        marcado: false,
        pago: i === 0 && selected.baixaPrimeira ? true : false,
        texto: "",
        tipo: "1",
        valor: valorParcela,
        vencimento: itemData,
        id: "",
        contaPagarId: "",
        contaReceberId: "",
        dataPago: new Date(),
        obs: "",
        tipoRecebimento : tipoRecebimento,
        
      };
      newList.push(obj);
    }
    setTimeout(() => {
      setItemList(newList);
    }, 300);
  };

  useEffect(() => {
    const initialize = async () => {
      try {
        await Promise.all([
          loadData(),
          loadClient(),
          loadFilial(),
          loadCategoria(),
          loadDepto(),
          loadContaFinaceiro(),
          loadPagamento(),
          loadUsers()
        ]);
      } catch (error) {
        // Handle errors if needed
        console.error("Error during initialization:", error);
      }
    };

    initialize();
  }, []);

  return {
    list,
    show,
    error,
    errorMsg,
    errorTitle,
    showDelete,
    accountSelected,
    loading,
    cancelRef,
    showError,
    closeError,
    showModal,
    getLink,
    showDeleteModal,
    edit,
    closeDelete,
    deletar,
    add,
    save,
    selectedClient,
    changeClient,
    loadClient,
    changeInput,
    uploadPictures,
    clients,
    changeFiliais,
    filiais,
    selectedFilial,
    categoria,
    itemList,
    addRowItem,
    editRow,
    deleteRow,
    usuario,
    depto,
    selectedDepto,
    selectedCentroCusto,
    centroCusto,
    changeCentroCusto,
    changeDepto,
    changeCondicaoPagamento,
    condicaoPagamentos,
    selectedCondicaoPagamentos,
    changeConta,
    selectedConta,
    generateParcela,
    contaFinanceiroLista,
    users,
    selectedUser,
    changeUser
  };
};
export default useContasReceber;
